import { type IUser } from '@/models/user.model'
import { clearLocalStorage, persistLocalStorage } from '@/utils/localStorage.util'
import { createSlice } from '@reduxjs/toolkit'

// import axios from 'axios'

export const EmptyUserState: IUser = {
  id: 0,
  email: '',
  name: '',
  id_company_area: 0,
  active: 0,
  created_at: '',
  updated_at: '',
  id_role: 0,
  name_role: '',
  permisos: [],
  token: '',
  logged: true,
  id_store: 0
}

export const UserKey = 'user'

const userSlice = createSlice({
  name: 'auth',
  initialState: localStorage.getItem(UserKey) !== null ? JSON.parse(String(localStorage.getItem(UserKey))) : EmptyUserState,
  reducers: {
    setUser: (state, action) => {
      console.log('user =>', state)
      persistLocalStorage(UserKey, action.payload)
      return action.payload
    },
    updateUser: (state, action) => {
      const result = { ...state, ...action.payload }
      persistLocalStorage(UserKey, result)
      return result
    },
    resetUser: () => {
      clearLocalStorage(UserKey)
      return EmptyUserState
    }
  }
})

export const { setUser, updateUser, resetUser } = userSlice.actions

export default userSlice.reducer
